import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { TheTrap } from './TheTrap';
import { OldSolutions } from './OldSolutions';
import { Sistema3C } from './Sistema3C';
import { WhatsIncluded } from './WhatsIncluded';
import { Bonuses } from './Bonuses';
import { WhoItsFor } from './WhoItsFor';
import { HowToUse } from './HowToUse';
import { PricingCTA } from './PricingCTA';
import { SalesToast } from './SalesToast';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-151">
      <Hero data-id="element-152" />
      <PainPoints data-id="element-153" />
      <TheTrap data-id="element-154" />
      <OldSolutions data-id="element-155" />
      <Sistema3C data-id="element-156" />
      <WhatsIncluded data-id="element-157" />
      <Bonuses data-id="element-158" />
      <WhoItsFor data-id="element-159" />
      <HowToUse data-id="element-160" />
      <PricingCTA data-id="element-161" />

      <footer className="py-8 text-center text-brown-body/40 text-sm" data-id="element-162">
        <p data-id="element-163">
          © {new Date().getFullYear()} Semana Resuelta. Todos los derechos
          reservados.
        </p>
      </footer>

      <SalesToast data-id="element-164" />
    </main>;
}